/** Tokenize the raw FU command protocol, including backtick-delimited arguments. */
export function tokenizeFabulaUltimaCommand(input: string): string[] {
  const tokens: string[] = [];
  let token = "";
  let inBackticks = false;

  const pushToken = () => {
    if (token.length > 0) {
      tokens.push(token);
      token = "";
    }
  };

  for (const character of input.trim()) {
    if (character === "\n" || character === "\r") {
      throw new SyntaxError("Command must be a single line");
    }
    if (character === "`") {
      inBackticks = !inBackticks;
      continue;
    }
    if (/\s/.test(character) && !inBackticks) {
      pushToken();
      continue;
    }
    token += character;
  }

  if (inBackticks) {
    throw new SyntaxError("Unclosed backtick-delimited argument");
  }
  pushToken();
  return tokens;
}

export function formatFabulaUltimaCommandArgument(value: string): string {
  if (value.includes("`") || /[\r\n]/.test(value)) {
    throw new SyntaxError("Command arguments cannot contain backticks or newlines");
  }
  return /\s/.test(value) ? `\`${value}\`` : value;
}

/** Keep embedded image bytes out of visible history and console feedback. */
export function formatFabulaUltimaCommandForDisplay(command: string): string {
  if (!command.trimStart().startsWith('avatar ')) return command;
  try {
    const parts = tokenizeFabulaUltimaCommand(command);
    if (parts.length === 3 && parts[0] === 'avatar' && parts[2] !== 'clear') {
      return `avatar ${formatFabulaUltimaCommandArgument(parts[1])} <image>`;
    }
  } catch { /* Preserve invalid commands so existing error reporting still works. */ }
  return command;
}
